























































import { Component, Vue } from 'vue-property-decorator';
import {
  FilterDTO, SearchRequestSortByEnum, SearchRequestSortOrderEnum,
} from '@/api';
import { getAssetUrl } from '@/utils';
import FilterIcon from '@/assets/icons/filters.svg';
import CatalogFilter from '@/components/CatalogFilter.vue';
import CatalogItem from '@/components/CatalogItem.vue';
import { catalogModule, shoppingModule } from '@/store';
import ShoppingItem from '@/components/catalog/CatalogShoppingItem.vue';
import ShoppingClientObject from '@/components/catalog/CatalogClientObject.vue';
import BaseLayout from './BaseLayout.vue';

@Component({
  name: 'catalog',
  components: {
    FilterIcon,
    CatalogFilter,
    CatalogItem,
    BaseLayout,
    ShoppingItem,
    ShoppingClientObject,
  },
})

export default class ShoppingCatalogPage extends Vue {
  isFiltersOpen: boolean = false

  tab = 'cart';

  get catalog() {
    return catalogModule.catalog;
  }

  get filtersString(): string {
    return this.catalog.filters.map((item: FilterDTO) => item.name).join(' ∙ ');
  }

  get shopped() {
    return shoppingModule.items;
  }

  get shopping() {
    return shoppingModule.current;
  }

  get sumPrice() {
    return shoppingModule.items.reduce((sum, item) => sum
      + (item.price && item.price.price ? item.price.price : 0), 0);
  }

  get shoppedCount() {
    return this.shopped.length;
  }

  get sorting() {
    return `${this.params.sortBy}.${this.params.sortOrder}`;
  }

  set sorting(value: string) {
    const [sortBy, sortOrder] = value.split('.') as [SearchRequestSortByEnum, SearchRequestSortOrderEnum];
    catalogModule.updateParams({ sortBy, sortOrder, page: 1 });
    this.catalogFetch();
  }

  get params() {
    return catalogModule.params;
  }

  get sortingOptions() {
    return [
      {
        label: 'Цена: по возрастанию',
        value: 'PRICE.ASC',
      },
      {
        label: 'Цена: по убыванию',
        value: 'PRICE.DESC',
      },
      {
        label: 'Дата: по возрастанию',
        value: 'DATE.ASC',
      },
      {
        label: 'Дата: по убыванию',
        value: 'DATE.DESC',
      },
    ];
  }

  created() {
    this.catalogFetch();
  }

  catalogFetch() {
    catalogModule.fetchItems(this.params);
  }

  itemPicUrl = (path: string) => getAssetUrl(path)

  applyFilters(filters: FilterDTO[]) {
    this.isFiltersOpen = false;
    catalogModule.updateParams({
      GENDER: [],
      CATEGORY: [],
      COLOR: [],
      SUPPLIER: [],
      BRAND: [],
      // MATERIAL: [],
      ITEM_NAME: [],
      PRICE: [],
      page: 1,
    });
    catalogModule.applyFilters(filters);
    const f = catalogModule.allChildren.reduce((acc: any, item: any) => ({
      ...acc,
      [item.type]: acc[item.type] ? acc[item.type].concat(item.id) : [item.id],
    }),
    {});
    catalogModule.updateParams(f);
    this.catalogFetch();
  }

  onPageChange(newPage: number) {
    catalogModule.updateParams({ page: newPage });
    this.catalogFetch();
  }
}
